import { Desktop } from './Desktop'

interface ToolbarProps {
  isVisible?: boolean
}

export const Toolbar = ({ isVisible = true }: ToolbarProps) => {
  // const isMobile = useIsMobile() // TODO: wait design for mobile toolbar

  return <Desktop isVisible={isVisible} />
}
